export default "__VITE_ASSET__BcNcOugH__"